export const projectData = {
  jjsgUserPlayStore: "https://play.google.com/store/apps/details?id=com.jjsg",
  jjsgAdminPlayStore:
    "https://play.google.com/store/apps/details?id=com.jjsgadminapp",
  atharavaStudentPlayStore:
    "https://play.google.com/store/apps/details?id=com.moddsoftdevelopers.schoolapp",
  atharavaTeacherPlayStore:
    "https://play.google.com/store/apps/details?id=com.moddsoftdevelopers.schooladminapp",
  atharavaWebsite: "https://atharavavidyalaya.com/",
  ratlerRushPlayStore:
    "https://play.google.com/store/apps/details?id=com.moddsoft.snakegame",
  ratlerRushGithub: "https://github.com/ModdSoft/Snake-Game",
  kidsPlayStore:
    "https://play.google.com/store/apps/details?id=com.moddsoft.kidslearningapp",
  kidsGithub: "https://github.com/ModdSoft/Kids-Learning-App",
  websiteLive: "https://dhyeymodi.netlify.app/",
  websiteGithub: "https://github.com/ModdSoft/dhyey-portfolio",
  worldcupGithub:
    "https://github.com/dhyeymodi2001/Cricket-T20-WorldCup-Analysis",
  walmartGithub: "https://github.com/dhyeymodi2001/Walmart-Data-Analysis",
  blinkitGithub: "https://github.com/dhyeymodi2001/Blinkit-Sales-Analysis",
  housePriceLive: "https://house-price-prediction1.netlify.app/",
  housePriceKaggle:
    "https://www.kaggle.com/competitions/home-data-for-ml-course",
  housePriceMedium:
    "https://medium.com/@dhyeymodi21/building-a-house-price-prediction-app-from-dataset-to-deployment-aebf68a9ae5c",
  busRouteLive: "https://bus-route-optimizer.netlify.app/",
  busRouteMedium:
    "https://medium.com/@dhyeymodi21/bus-route-optimization-7faceecafbac",
};
